import { State } from "reducers";
import { onHomepage } from "selectors/browse";

export const inBrowse = (state: State) => !state.app.showSwitcher;

export const switcherIsShowing = (state: State) =>
  state.app.showSwitcher && onHomepage(state);

export const focusArea = (state: State) => state.app.focusArea;
